module.exports = __webpack_public_path__ + "img/how__visual-3@2x.3e103591.jpg";